import React from "react";
import { Icon } from "./registry";
import { hostedVisuals, visualKind, visualTitle } from "./lib/visuals";
/* ============================================================
   Fence Works — the renders on a fence quote (docs/SERVICE_SWITCHER_PLAN.md
   §13 item 27). The 3D studio (viz3d/Studio.tsx) stands the quoted fence in
   the customer's photo or builds it in a 3D yard and saves the picture onto
   the estimate (q.visuals, kind "render" / "render3d"; lib/visuals.ts). This
   card lists them on the quote page — the same ones the customer sees under
   "Your fence, previewed" on the hub — and opens the studio on this estimate.
   The coating side has its own card (coatpreview.tsx CoatingPreviewCard).
   ============================================================ */
export function RendersCard({ q, store, canEdit = true, go }: { q: any; store: any; canEdit?: boolean; go?: (route: string, params?: any) => void }) {
  const all = Array.isArray(q && q.visuals) ? q.visuals : [];
  const renders = all.filter((v: any) => v && typeof v.url === "string" && visualKind(v) !== "preview");
  const hosted = hostedVisuals(renders);
  const remove = (id: string) => store.updateQuote(q.id, { visuals: all.filter((v: any) => v && v.id !== id) });
  const open = () => { if (go) go("visualizer", { from: "quote", quoteId: q.id }); };
  return (
    <div className="card pad" style={{ marginTop: 12 }} data-tour="fence-renders">
      <div className="row between" style={{ flexWrap: "wrap", gap: 8, marginBottom: renders.length ? 10 : 0 }}>
        <div>
          <div className="kicker kicker-teal"><Icon name="image" size={13} /> Their fence, previewed</div>
          <p className="muted" style={{ margin: "2px 0 0", fontSize: 12.5 }}>{renders.length ? `${hosted.length} of ${renders.length} on their page` : "The quoted fence standing in their own photo, or built in 3D — saved from the Visualizer, shown on their page."}{renders.length > hosted.length ? " — the rest reach it once this device is back online." : ""}</p>
        </div>
        {canEdit && go && <button className="btn btn-outline btn-sm" onClick={open}><Icon name="bolt" size={13} />{renders.length ? "Another view" : "Open the Visualizer"}</button>}
      </div>
      {renders.length > 0 && (
        <div className="cp-grid">
          {renders.slice().sort((a: any, b: any) => (Number(b.at) || 0) - (Number(a.at) || 0)).map((v: any) => (
            <figure key={v.id} className="cp-fig">
              <a href={v.url} target="_blank" rel="noopener"><img src={v.url} alt={v.label || "Render"} /></a>
              <figcaption className="row between" style={{ gap: 6, fontSize: 12 }}>
                <span style={{ minWidth: 0 }}><span className="muted">{visualTitle(visualKind(v), "fence").replace(/^Your /, "")}</span>{v.label ? <> · {v.label}</> : null}{v.pending ? <span className="faint"> · not on their page yet</span> : null}</span>
                {canEdit && <button className="proj-del" style={{ background: "none", border: 0, color: "var(--fg-3)", cursor: "pointer" }} aria-label="Remove render" onClick={() => remove(v.id)}><Icon name="trash" size={13} /></button>}
              </figcaption>
            </figure>
          ))}
        </div>
      )}
    </div>
  );
}
